<template>
  <v-dialog persistent v-model="get_dialogMain.dialog" :width="get_dialogMain.withWindows" justify-center>
      <v-card width="auto" tile>
          <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title><h3>{{get_dialogMain.title}}</h3></v-toolbar-title>
            <v-spacer/>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>

          <v-card-text class="pa-5">
            <v-row dense>
              <v-col cols="12" sm="6">
                <SelectedMain :itemAction="selectActividadField" :on-success="tipoActividad" :on-error="errorComponents" />
              </v-col>
              <v-col cols="12" sm="6">
                <SelectedMain :itemAction="selectServicioField" :on-success="actionFieldData" />
              </v-col>
            </v-row>
              <v-divider/>
            <FormsMain v-if="form.id" :formCreate="form"
              :on-success="saveMesaAyuda"
              :on-cancel="closeDialog"
              :model="descripcion"/>

            <v-alert v-if="showActividad" prominent type="error" dense>
              <v-row dense align="center">
                <v-col class="grow">Sin acceso a las Actividades</v-col>
                <v-col class="shrink" >
                  <v-btn @click="HIDDE_DIALOG_MAIN">Cerrar</v-btn>
                </v-col>
              </v-row>
            </v-alert>

          </v-card-text>
      </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import SelectedMain from '@/components/fields/selectedMain'

import FormsMain from '@/components/forms/formsMain'
export default {
  name: 'dialogMain',
  props: ['body'],
  data: () => ({
    selectActividadField: {
      name: 'Tipo Actividad',
      nameid: 'tipo_proceso_id',
      url: '/tipo-actividades/solicitudes',
      value: 'tipo_proceso_id'
    },
    showActividad: false,
    selectServicioField: {
      name: 'Tipo Servicio',
      nameid: 'servicio',
      url: '/tipos-atencion',
      value: 'id'
    },

    form: {
      status_start: {
        formulario: {
          fields: []
        }
      },
      status_finish: {
        formulario: {
          fields: []
        },
        estatus: ''
      }
    },
    default: {
      status_start: {
        formulario: {
          fields: []
        }
      },
      status_finish: {
        formulario: {
          fields: []
        },
        estatus: ''
      }
    },
    mesaAyuda: {},
    descripcion: {},
    user: {}
  }),
  components: {
    SelectedMain,
    FormsMain
  },
  mounted () {
    this.user = this.$cookies.get('user')
  },
  methods: {
    tipoActividad (obj) {
      this.mesaAyuda = {}
      this.mesaAyuda[obj.id] = (obj.data === undefined) ? null : obj.data
      if (obj.data !== undefined) {
        this.getFormDataUrl('ma.options', obj.data)
      } else {
        this.form = this.default
        this.mesaAyuda = {}
      }
    },
    errorComponents (field) {
      if (field.nameid === 'tipo_proceso_id') {
        this.showActividad = true
      }
    },
    actionFieldData (obj) {
      this.mesaAyuda[obj.id] = (obj.data === undefined) ? null : obj.data
    },
    ...mapActions(['getUrlServices', 'getFormServicesAction', 'postExecuteAction']),
    getFormDataUrl (url, actividad) {
      const router = this.get_urls[url]
      this.getFormServicesAction({ url: router, params: '/' + actividad })
    },
    saveMesaAyuda (model) {
      if (this.mesaAyuda.servicio) {
        model.empleado = this.user.empleado_id
        model.departamento = this.user.departamento_id
        model.tipo_proceso_id = this.mesaAyuda.tipo_proceso_id
        model.servicio = this.mesaAyuda.servicio

        const router = this.get_urls['ma.execute']
        this.postExecuteAction({ url: router, data: model })
      } else {
        this.SET_LOADING_STATUS(false)
        this.$swal({
          type: 'warning',
          icon: 'warning',
          title: 'Advertencia!',
          text: 'se debe seleccionar un Tipo de Servicio'
        })
      }
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'RELOAD_DATA_OBJECT', 'SET_LOADING_STATUS']),
    closeDialog () {
      this.HIDDE_DIALOG_MAIN()
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objectsSecound', 'get_options', 'get_model'])
  },
  watch: {
    get_options (vals) {
      if (vals) {
        this.form = vals
      }
    },
    get_model (val) {
      this.SET_LOADING_STATUS(false)
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error !',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'succes',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Registro agregado correctamente !!'
      })
      this.RELOAD_DATA_OBJECT(val)
      this.closeDialog()
    }
  }
}
</script>
<style></style>
